// extracted by mini-css-extract-plugin
export default {"description":"OQrPxtIRlmqvHNvUWC6_","highlight":"hIKWLyJvUJBlL3F4fGHE"};